var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 10.2 2.5 6.7a.99.99 0 1 0-1.4 1.4l4.51 4.509a.55.55 0 0 0 .781 0l10.91-10.91A.99.99 0 1 0 15.9.3z"
})));
export default SvgCheckMark;